import {
  AS_CS_RECEIPT_STATUS_ALL,
  AS_CS_RECEIPT_STATUS_LABELS,
} from '../constants/asCsOptions';
import { AsCsReceiptStatus } from '../types/aiAgent/asCs';

export const isAsCsReceiptStatus = (value: string): value is AsCsReceiptStatus => {
  return (
    value === AsCsReceiptStatus.REQUEST ||
    value === AsCsReceiptStatus.INPROGRESS ||
    value === AsCsReceiptStatus.COMPLETE ||
    value === AsCsReceiptStatus.CANCEL
  );
};

export const isAsCsReceiptFilterStatus = (value: string): value is typeof AS_CS_RECEIPT_STATUS_ALL | AsCsReceiptStatus => {
  return value === AS_CS_RECEIPT_STATUS_ALL || isAsCsReceiptStatus(value);
};

export const getAsCsReceiptStatusLabel = (status?: string | null): string => {
  if (!status) {
    return '-';
  }

  return isAsCsReceiptStatus(status) ? AS_CS_RECEIPT_STATUS_LABELS[status] : status;
};
